import {dataTestId} from '@hconnect/uikit'
import {HPButton} from '@hconnect/uikit/src/lib2'
import {Add} from '@mui/icons-material'
import {Stack} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {PastFutureTimeframeSelect} from '../components/PastFutureTimeframeSelect'
import {FEATURE_NAMESPACE} from '../consts'
import {usePlanRange} from '../hooks'
import {
  useSelectedMaterialOrder,
  useSelectedTimeframe,
  useMaterialOrderPermissions
} from '../providers'

const TIMEFRAME_DURATIONS_DAYS = [1, 3, 5, 9, 15]

type MaterialOrdersTitleActionsProps = {
  canAddMaterialOrder: boolean
}

export const MaterialOrdersTitleActions: React.FC<MaterialOrdersTitleActionsProps> = ({
  canAddMaterialOrder
}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const {selectedTimeframe, setSelectedTimeframe} = useSelectedTimeframe()
  if (!selectedTimeframe) {
    throw new Error('BUG: Selected timeframe is not defined')
  }
  const {setSelectedMaterialOrder} = useSelectedMaterialOrder()
  const [startOfPlan] = usePlanRange()

  const {canChangeMaterialOrders} = useMaterialOrderPermissions()

  return (
    <Stack direction="row" spacing={1.5}>
      <PastFutureTimeframeSelect
        pastDurationDays={TIMEFRAME_DURATIONS_DAYS}
        futureDurationDays={TIMEFRAME_DURATIONS_DAYS}
        startOfToday={startOfPlan.clone().startOf('day')}
        timeframe={selectedTimeframe}
        onTimeframeChange={setSelectedTimeframe}
      />
      {canAddMaterialOrder && (
        <HPButton
          startIcon={<Add />}
          variant="contained"
          color="primary"
          backgroundMode="light"
          onClick={() => setSelectedMaterialOrder({id: undefined})}
          disabled={!canChangeMaterialOrders}
          {...dataTestId('create_order_button')}
        >
          {t('stock.createOrder')}
        </HPButton>
      )}
    </Stack>
  )
}
